module.exports = __webpack_public_path__ + "img/6.771a8411.jpg";